module.exports = __webpack_public_path__ + "static/img/logo.a3d4d04e.svg";